<script>
  import animations from '/lib/animations'
  import { fly }    from 'svelte/transition'
</script>

<style lang="scss">
  h1 {
    span {
      position: relative;
      z-index: 2;
      margin: 0 -$GU / 2;
      padding: 0 $GU / 2;
      background: #fcb045;
      background: linear-gradient(to right, #fcb045, #fd1d1d, #833ab4);
      box-shadow: 0 0 $GU $black;
    }
  }
</style>

<div in:fly={animations.in} out:fly={animations.out}>
  <h1>
    <span>Free</span>
    Foucault
  </h1>
  <p>Foucault for the rest of us</p>
</div>
